/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceStreamZoneTickerItem } from './SurfaceStreamZoneTickerItem';
import {
    SurfaceStreamZoneTickerItemFromJSON,
    SurfaceStreamZoneTickerItemFromJSONTyped,
    SurfaceStreamZoneTickerItemToJSON,
    SurfaceStreamZoneTickerItemToJSONTyped,
} from './SurfaceStreamZoneTickerItem';
import type { SurfaceStreamZoneEarnItem } from './SurfaceStreamZoneEarnItem';
import {
    SurfaceStreamZoneEarnItemFromJSON,
    SurfaceStreamZoneEarnItemFromJSONTyped,
    SurfaceStreamZoneEarnItemToJSON,
    SurfaceStreamZoneEarnItemToJSONTyped,
} from './SurfaceStreamZoneEarnItem';
import type { SurfaceStreamZoneOverlaySponsor } from './SurfaceStreamZoneOverlaySponsor';
import {
    SurfaceStreamZoneOverlaySponsorFromJSON,
    SurfaceStreamZoneOverlaySponsorFromJSONTyped,
    SurfaceStreamZoneOverlaySponsorToJSON,
    SurfaceStreamZoneOverlaySponsorToJSONTyped,
} from './SurfaceStreamZoneOverlaySponsor';

/**
 * 
 * @export
 * @interface SurfaceStreamZoneConfig
 */
export interface SurfaceStreamZoneConfig {
    /**
     * Twitch or YouTube live stream URL (live mode)
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    channelUrl?: string;
    /**
     * Image shown when no live stream is active (demo/offline mode)
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    placeholderImageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceStreamZoneConfig
     */
    showChat?: boolean;
    /**
     * Top-left OBS overlay — hub logo + name + member count
     * @type {boolean}
     * @memberof SurfaceStreamZoneConfig
     */
    hubBadgeEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    hubBadgeMemberCount?: string;
    /**
     * Top-right OBS overlay — latest activity text
     * @type {boolean}
     * @memberof SurfaceStreamZoneConfig
     */
    activityNotificationEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    activityNotificationText?: string;
    /**
     * Bottom-left OBS overlay — active challenge progress bar
     * @type {boolean}
     * @memberof SurfaceStreamZoneConfig
     */
    challengeProgressEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    challengeProgressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    challengeProgressName?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStreamZoneConfig
     */
    challengeProgressValue?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    challengeProgressStat?: string;
    /**
     * Bottom-right OBS overlay — sponsor pills
     * @type {boolean}
     * @memberof SurfaceStreamZoneConfig
     */
    sponsorPillsEnabled?: boolean;
    /**
     * 
     * @type {Array<SurfaceStreamZoneOverlaySponsor>}
     * @memberof SurfaceStreamZoneConfig
     */
    sponsorPillSponsors?: Array<SurfaceStreamZoneOverlaySponsor>;
    /**
     * Title shown in the stream bar below the player
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    streamTitle?: string;
    /**
     * URL for the Chat button in the stream bar
     * @type {string}
     * @memberof SurfaceStreamZoneConfig
     */
    chatButtonUrl?: string;
    /**
     * 
     * @type {Array<SurfaceStreamZoneEarnItem>}
     * @memberof SurfaceStreamZoneConfig
     */
    earnItems?: Array<SurfaceStreamZoneEarnItem>;
    /**
     * 
     * @type {Array<SurfaceStreamZoneTickerItem>}
     * @memberof SurfaceStreamZoneConfig
     */
    tickerItems?: Array<SurfaceStreamZoneTickerItem>;
    /**
     * Ticker scroll animation duration in seconds (default 25)
     * @type {number}
     * @memberof SurfaceStreamZoneConfig
     */
    tickerSpeed?: number;
}

/**
 * Check if a given object implements the SurfaceStreamZoneConfig interface.
 */
export function instanceOfSurfaceStreamZoneConfig(value: object): value is SurfaceStreamZoneConfig {
    return true;
}

export function SurfaceStreamZoneConfigFromJSON(json: any): SurfaceStreamZoneConfig {
    return SurfaceStreamZoneConfigFromJSONTyped(json, false);
}

export function SurfaceStreamZoneConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStreamZoneConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'channelUrl': json['channelUrl'] == null ? undefined : json['channelUrl'],
        'placeholderImageUrl': json['placeholderImageUrl'] == null ? undefined : json['placeholderImageUrl'],
        'showChat': json['showChat'] == null ? undefined : json['showChat'],
        'hubBadgeEnabled': json['hubBadgeEnabled'] == null ? undefined : json['hubBadgeEnabled'],
        'hubBadgeMemberCount': json['hubBadgeMemberCount'] == null ? undefined : json['hubBadgeMemberCount'],
        'activityNotificationEnabled': json['activityNotificationEnabled'] == null ? undefined : json['activityNotificationEnabled'],
        'activityNotificationText': json['activityNotificationText'] == null ? undefined : json['activityNotificationText'],
        'challengeProgressEnabled': json['challengeProgressEnabled'] == null ? undefined : json['challengeProgressEnabled'],
        'challengeProgressLabel': json['challengeProgressLabel'] == null ? undefined : json['challengeProgressLabel'],
        'challengeProgressName': json['challengeProgressName'] == null ? undefined : json['challengeProgressName'],
        'challengeProgressValue': json['challengeProgressValue'] == null ? undefined : json['challengeProgressValue'],
        'challengeProgressStat': json['challengeProgressStat'] == null ? undefined : json['challengeProgressStat'],
        'sponsorPillsEnabled': json['sponsorPillsEnabled'] == null ? undefined : json['sponsorPillsEnabled'],
        'sponsorPillSponsors': json['sponsorPillSponsors'] == null ? undefined : ((json['sponsorPillSponsors'] as Array<any>).map(SurfaceStreamZoneOverlaySponsorFromJSON)),
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'chatButtonUrl': json['chatButtonUrl'] == null ? undefined : json['chatButtonUrl'],
        'earnItems': json['earnItems'] == null ? undefined : ((json['earnItems'] as Array<any>).map(SurfaceStreamZoneEarnItemFromJSON)),
        'tickerItems': json['tickerItems'] == null ? undefined : ((json['tickerItems'] as Array<any>).map(SurfaceStreamZoneTickerItemFromJSON)),
        'tickerSpeed': json['tickerSpeed'] == null ? undefined : json['tickerSpeed'],
    };
}

export function SurfaceStreamZoneConfigToJSON(json: any): SurfaceStreamZoneConfig {
    return SurfaceStreamZoneConfigToJSONTyped(json, false);
}

export function SurfaceStreamZoneConfigToJSONTyped(value?: SurfaceStreamZoneConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelUrl': value['channelUrl'],
        'placeholderImageUrl': value['placeholderImageUrl'],
        'showChat': value['showChat'],
        'hubBadgeEnabled': value['hubBadgeEnabled'],
        'hubBadgeMemberCount': value['hubBadgeMemberCount'],
        'activityNotificationEnabled': value['activityNotificationEnabled'],
        'activityNotificationText': value['activityNotificationText'],
        'challengeProgressEnabled': value['challengeProgressEnabled'],
        'challengeProgressLabel': value['challengeProgressLabel'],
        'challengeProgressName': value['challengeProgressName'],
        'challengeProgressValue': value['challengeProgressValue'],
        'challengeProgressStat': value['challengeProgressStat'],
        'sponsorPillsEnabled': value['sponsorPillsEnabled'],
        'sponsorPillSponsors': value['sponsorPillSponsors'] == null ? undefined : ((value['sponsorPillSponsors'] as Array<any>).map(SurfaceStreamZoneOverlaySponsorToJSON)),
        'streamTitle': value['streamTitle'],
        'chatButtonUrl': value['chatButtonUrl'],
        'earnItems': value['earnItems'] == null ? undefined : ((value['earnItems'] as Array<any>).map(SurfaceStreamZoneEarnItemToJSON)),
        'tickerItems': value['tickerItems'] == null ? undefined : ((value['tickerItems'] as Array<any>).map(SurfaceStreamZoneTickerItemToJSON)),
        'tickerSpeed': value['tickerSpeed'],
    };
}

